import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessServiceStore = {
  state: {},
  getters,
  mutations,
  actions
}

export default BusinessServiceStore